<template>
  <div v-if="project" class="mr-3 mt-3 ml-3 mb-3">
    <h3 v-if="!hasSession">
      <i class="fa fa-exclamation-circle mr-3 text-primary" aria-hidden="true"></i>
      You are not Logged In
    </h3>
    <h3>
      <i class="fa fa-exclamation-circle mr-3 text-primary" aria-hidden="true"></i>
      You are not a Manager of this Project
    </h3>
    <p>
      <span class="font-weight-bold">{{ project.name }}</span> requires you to
      be  {{ hasSession ? 'a manager ' : ' logged in ' }} to view the '{{ page }}' page.
    </p>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "RequiresManager",
  props: {
    page: {
      type: String,
      required: false
    }
  },
  computed: {
    ...mapGetters({
      project: "project/get/project",
      hasSession: "user/profile/hasSession",
    })
  },
};
</script>
